export default __webpack_public_path__ + "static/media/featSportBg.0a63168a.png";